<template>
  <Row class="header-bar-container">
    <i-col span="24" class="header-col">
      <div class="header-left">
        <slot name="left"></slot>
      </div>
      <div class="header-right">
        <slot name="right"></slot>
      </div>
    </i-col>
  </Row>
</template>

<script>
export default {
  props: {
    labelWidth: { type: String, default: '40px' },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';

.header-bar-container {
  .header-col {
    @include display-flex(space-between, center);
    height: auto;
    margin-bottom: 6px;
  }

  .header-left,
  .header-right {
    display: flex;
  }

  ::v-deep {
    .header-item {
      display: inline-block;
      margin-bottom: 10px;
    }

    .header-item.btn,
    .header-left .header-item {
      margin-left: 0px;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }

    .header-right .header-item:not(:last-child) {
      margin-right: 10px;
    }

    /* search */
    .search-group {
      display: inline-block;
    }

    .search-group.margin20 {
      display: inline-block;
      margin: 0 16px;
    }

    .search-group.margin10 {
      display: inline-block;
      margin: 0 6px;
    }

    .search-group .group-item:not(:last-child) {
      margin-right: 6px;
    }

    .search-group .group-item.btn {
      width: 80px;
    }

    .label {
      display: inline-block;
      text-align: left;
      color: #999;
      font-size: 14px;
      line-height: 36px;
      min-width: v-bind(labelWidth);
    }
  }
}
</style>
